import { render, staticRenderFns } from "./GoodCard.vue?vue&type=template&id=c6251af4&scoped=true&"
import script from "./GoodCard.vue?vue&type=script&lang=js&"
export * from "./GoodCard.vue?vue&type=script&lang=js&"
import style0 from "./GoodCard.vue?vue&type=style&index=0&id=c6251af4&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6251af4",
  null
  
)

export default component.exports